// extracted by mini-css-extract-plugin
export var askAiIcon = "_mc-9";
export var container = "_mc-0";
export var groupSeparator = "_mc-a";
export var highlight = "_mc-4";
export var resultIcon = "_mc-5";
export var resultItem = "_mc-7";
export var resultSubtitle = "_mc-3";
export var resultTitle = "_mc-2";
export var resultsList = "_mc-1";
export var searchGroup = "_mc-6";
export var selected = "_mc-8";